// extracted by mini-css-extract-plugin
export var form = "_4e-0";